import {Component, OnDestroy, OnInit,} from '@angular/core';
import {Router} from '@angular/router';
import {BackendApiService} from '../../../app/services/backend-api.service';
import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';
import {LocalStorageService} from 'angular-web-storage';
import {BnNgIdleService} from 'bn-ng-idle';
import {NgbTooltipConfig} from '@ng-bootstrap/ng-bootstrap';
import {ToolsService} from '../../services/tools.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {UserNotificationService} from '../../services/usernotification.service';

@Component({
   selector: 'app-temp-basic',
   templateUrl: './temp-basic.component.html',
   styleUrls: ['./temp-basic.component.scss'],
   animations: [
      trigger('notificationBottom', [
         state('an-off, void',
           style({
              overflow: 'hidden',
              height: '0px',
           })
         ),
         state('an-animate',
           style({
              overflow: 'visible',
              height: AUTO_STYLE,
           })
         ),
         transition('an-off <=> an-animate', [
            animate('400ms ease-in-out')
         ])
      ]),
      trigger('slideInOut', [
         state('in', style({
            width: '280px',
            // transform: 'translate3d(0, 0, 0)'
         })),
         state('out', style({
            width: '0',
            // transform: 'translate3d(100%, 0, 0)'
         })),
         transition('in => out', animate('400ms ease-in-out')),
         transition('out => in', animate('400ms ease-in-out'))
      ]),
      trigger('mobileHeaderNavRight', [
         state('nav-off, void',
           style({
              overflow: 'hidden',
              height: '0px',
           })
         ),
         state('nav-on',
           style({
              height: AUTO_STYLE,
           })
         ),
         transition('nav-off <=> nav-on', [
            animate('400ms ease-in-out')
         ])
      ]),
      trigger('fadeInOutTranslate', [
         transition(':enter', [
            style({opacity: 0}),
            animate('400ms ease-in-out', style({opacity: 1}))
         ]),
         transition(':leave', [
            style({transform: 'translate(0)'}),
            animate('400ms ease-in-out', style({opacity: 0}))
         ])
      ]),
      trigger('mobileMenuTop', [
         state('no-block, void',
           style({
              overflow: 'hidden',
              height: '0px',
           })
         ),
         state('yes-block',
           style({
              height: AUTO_STYLE,
           })
         ),
         transition('no-block <=> yes-block', [
            animate('400ms ease-in-out')
         ])
      ])
   ]
})
export class TempBasicComponent implements OnInit, OnDestroy {
   public animateSidebar: string;
   public navType: string;
   public themeLayout: string;
   public verticalPlacement: string;
   public verticalLayout: string;
   public pcodedDeviceType: string;
   public verticalNavType: string;
   public verticalEffect: string;
   public vnavigationView: string;
   public freamType: string;
   public sidebarImg: string;
   public sidebarImgType: string;
   public layoutType: string;
   
   public headerTheme: string;
   public pcodedHeaderPosition: string;
   
   public liveNotification: string;
   public liveNotificationClass: string;
   
   public profileNotification: string;
   public profileNotificationClass: string;
   
   public chatSlideInOut: string;
   public innerChatSlideInOut: string;
   
   public searchWidth: number;
   public searchWidthString: string;
   
   public navRight: string;
   public windowWidth: number;
   public chatTopPosition: string;
   
   public toggleOn: boolean;
   public toggleIcon: string;
   public navBarTheme: string;
   public activeItemTheme: string;
   public pcodedSidebarPosition: string;
   
   public headerFixedTop: string;
   
   public menuTitleTheme: string;
   public dropDownIcon: string;
   public subItemIcon: string;
   
   public displayBoxLayout: string;
   public isVerticalLayoutChecked: boolean;
   public isSidebarChecked: boolean;
   public isHeaderChecked: boolean;
   public headerFixedMargin: string;
   public sidebarFixedHeight: string;
   public sidebarFixedNavHeight: string;
   public itemBorderStyle: string;
   public subItemBorder: boolean;
   public itemBorder: boolean;
   
   public isCollapsedSideBar: string;
   public perfectDisable: string;
   
   public config: any;
   public searchInterval: any;
   public usuario;
   
   scroll = (): void => {
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 50) {
         if (this.isSidebarChecked === true) {
            this.pcodedSidebarPosition = 'fixed';
         }
         
         if (this.pcodedDeviceType === 'desktop') {
            this.headerFixedTop = '0';
         }
         
         this.sidebarFixedNavHeight = '100%';
      } else {
         if (this.pcodedDeviceType === 'desktop') {
            this.headerFixedTop = 'auto';
         }
         
         this.pcodedSidebarPosition = 'absolute';
         this.sidebarFixedNavHeight = '';
      }
   };
   
   constructor(
     public router: Router,
     public ngbTooltipConfig: NgbTooltipConfig,
     public service: BackendApiService,
     public storage: LocalStorageService,
     public route: Router,
     private bnIdle: BnNgIdleService,
     private userNotification: UserNotificationService,
     private readonly jwtHelperService: JwtHelperService
   ) {
      ngbTooltipConfig.container = 'body';
      
      this.bnIdle.startWatching(5400).subscribe((res) => {
         const oToken = this.storage.get('jwt');
         const bTokenExpired = this.jwtHelperService.isTokenExpired(oToken);
   
         if (bTokenExpired) {
            this.userNotification.modalInfo(
              'warning',
              'Sesión caducada',
              'Por seguridad, vuelve a iniciar sesión'
            );
            
            this.logout();
            return false;
         }
      });
      
      this.animateSidebar = '';
      this.navType = 'st2';
      this.themeLayout = 'vertical';
      this.verticalPlacement = 'left';
      this.verticalLayout = 'wide';
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'collapsed';
      this.verticalEffect = 'shrink';
      this.vnavigationView = 'view1';
      this.freamType = 'theme1';
      this.sidebarImg = 'false';
      this.sidebarImgType = 'img1';
      this.layoutType = 'light'; // light(default) dark(dark)
      this.headerTheme = 'theme1'; // theme1(default)
      this.pcodedHeaderPosition = 'fixed';
      this.headerFixedTop = 'auto';
      this.liveNotification = 'an-off';
      this.profileNotification = 'an-off';
      this.chatSlideInOut = 'out';
      this.innerChatSlideInOut = 'out';
      this.searchWidth = 0;
      this.navRight = 'nav-off';
      this.toggleOn = true;
      this.toggleIcon = 'icon-toggle-right';
      this.navBarTheme = 'themelight1'; // themelight1(default) theme1(dark)
      this.activeItemTheme = 'theme1';
      this.pcodedSidebarPosition = 'fixed';
      this.menuTitleTheme = 'theme1'; // theme1(default) theme10(dark)
      this.dropDownIcon = 'style1';
      this.subItemIcon = 'style1';
      this.displayBoxLayout = 'd-none';
      this.isVerticalLayoutChecked = true;
      this.isSidebarChecked = true;
      this.isHeaderChecked = true;
      this.headerFixedMargin = '100px'; // 50px
      this.sidebarFixedHeight = 'calc(100vh - 55px)'; // calc(100vh - 190px)
      this.itemBorderStyle = 'none';
      this.subItemBorder = true;
      this.itemBorder = true;
      this.isCollapsedSideBar = 'no-block';
      this.perfectDisable = '';
      this.windowWidth = window.innerWidth;
      
      this.setMenuAttributes(this.windowWidth);
      this.setHeaderAttributes(this.windowWidth);
      
      // dark theme
      /*this.setLayoutType('dark');*/
      
      // light-dark
      /*this.setLayoutType('dark');
      this.setNavBarTheme('themelight1');*/
      
      // dark-light theme
      /*this.setNavBarTheme('theme1');*/
      
      // box layout
      this.setHeaderPosition();
      this.setSidebarPosition();
      this.setVerticalLayout();
   }
   
   ngOnInit() {
      this.usuario = this.storage.get('usuario');
      this.setBackgroundPattern('theme1');
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
      this.perfectDisable = 'disabled';
      this.sidebarFixedHeight = '100%';
      this.setSidebarPosition();
   }
   
   login() {
      this.storage.remove('jwt');
      this.service.post('api/login', this.usuario).subscribe((data: any) => {
      
      }, error => {
         this.storage.clear();
         this.route.navigateByUrl('seguridad/login');
      });
   }
   
   public logout() {
      this.storage.clear();
      this.router.navigateByUrl('seguridad/login');
   }
   
   onResize(event) {
      this.windowWidth = event.target.innerWidth;
      this.setHeaderAttributes(this.windowWidth);
      
      let reSizeFlag = true;
      
      if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 992) {
         reSizeFlag = false;
      } else if (this.pcodedDeviceType === 'phone' && this.windowWidth < 768) {
         reSizeFlag = false;
      }
      
      /* for check device */
      // if (reSizeFlag) {
      //    this.setMenuAttributes(this.windowWidth);
      // }
   }
   
   setHeaderAttributes(windowWidth) {
      if (windowWidth <= 992) {
         this.navRight = 'nav-off';
      } else {
         this.navRight = 'nav-on';
      }
   }
   
   setMenuAttributes(windowWidth) {
      if (windowWidth >= 768 && windowWidth <= 992) {
         this.pcodedDeviceType = 'tablet';
         this.verticalNavType = 'offcanvas';
         this.verticalEffect = 'overlay';
         this.toggleIcon = 'icon-toggle-left';
         this.headerFixedTop = '80px';
         this.headerFixedMargin = '0';
      } else if (windowWidth < 768) {
         this.pcodedDeviceType = 'phone';
         this.verticalNavType = 'offcanvas';
         this.verticalEffect = 'overlay';
         this.toggleIcon = 'icon-toggle-left';
         this.headerFixedTop = '80px';
         this.headerFixedMargin = '0';
      } else {
         this.pcodedDeviceType = 'desktop';
         this.verticalNavType = 'expanded';
         this.verticalEffect = 'fullpage';
         this.toggleIcon = 'icon-toggle-right';
         this.headerFixedMargin = '100px';
      }
      // else if (windowWidth >= 1024 && windowWidth < 1366) {
      //   this.pcodedDeviceType = 'desktop';
      //   this.verticalNavType = 'collapsed';
      //   this.verticalEffect = 'shrink';
      //   this.toggleIcon = 'icon-toggle-left';
      //   this.perfectDisable = 'disabled';
      //   this.sidebarFixedHeight = '100%';
      // }
      
      //this.headerFixedMargin = '100px';
   }
   
   toggleHeaderNavRight() {
      this.navRight = this.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
      this.chatTopPosition = this.chatTopPosition === 'nav-on' ? '112px' : '';
      
      if (this.navRight === 'nav-off' && this.innerChatSlideInOut === 'in') {
         this.toggleInnerChat();
      }
      
      if (this.navRight === 'nav-off' && this.chatSlideInOut === 'in') {
         this.toggleChat();
      }
   }
   
   toggleLiveNotification() {
      if (this.profileNotification === 'an-animate') {
         this.toggleProfileNotification();
      }
      
      this.liveNotification = this.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
      this.liveNotificationClass = this.liveNotification === 'an-animate' ? 'show' : '';
      
      if (this.liveNotification === 'an-animate' && this.innerChatSlideInOut === 'in') {
         this.toggleInnerChat();
      }
      
      if (this.liveNotification === 'an-animate' && this.chatSlideInOut === 'in') {
         this.toggleChat();
      }
   }
   
   toggleProfileNotification() {
      if (this.liveNotification === 'an-animate') {
         this.toggleLiveNotification();
      }
      
      this.profileNotification = this.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
      this.profileNotificationClass = this.profileNotification === 'an-animate' ? 'show' : '';
      
      if (this.profileNotification === 'an-animate' && this.innerChatSlideInOut === 'in') {
         this.toggleInnerChat();
      }
      
      if (this.profileNotification === 'an-animate' && this.chatSlideInOut === 'in') {
         this.toggleChat();
      }
   }
   
   notificationOutsideClick(ele: string) {
      if (ele === 'live' && this.liveNotification === 'an-animate') {
         this.toggleLiveNotification();
      } else if (ele === 'profile' && this.profileNotification === 'an-animate') {
         this.toggleProfileNotification();
      }
   }
   
   toggleChat() {
      if (this.innerChatSlideInOut === 'in') {
         this.innerChatSlideInOut = 'out';
      } else {
         this.chatSlideInOut = this.chatSlideInOut === 'out' ? 'in' : 'out';
      }
   }
   
   toggleInnerChat() {
      this.innerChatSlideInOut = this.innerChatSlideInOut === 'out' ? 'in' : 'out';
   }
   
   ngOnDestroy() {
      if (this.searchInterval) {
         clearInterval(this.searchInterval);
      }
   }
   
   setVerticalLayout() {
      this.isVerticalLayoutChecked = !this.isVerticalLayoutChecked;
      
      if (this.isVerticalLayoutChecked) {
         this.verticalLayout = 'box';
         this.displayBoxLayout = '';
         this.pcodedHeaderPosition = 'relative';
         this.pcodedSidebarPosition = 'absolute';
         this.headerFixedMargin = '';
      } else {
         this.verticalLayout = 'wide';
         this.displayBoxLayout = 'd-none';
         this.pcodedHeaderPosition = 'fixed';
         this.pcodedSidebarPosition = 'fixed';
         this.headerFixedMargin = '50px';
      }
   }
   
   setBackgroundPattern(pattern: string) {
      // document.querySelector('body').setAttribute('themebg-pattern', pattern);
      // this.menuTitleTheme = this.freamType = this.activeItemTheme = this.headerTheme = pattern;
   }
   
   setSidebarPosition() {
      if (this.verticalNavType !== 'collapsed') {
         this.isSidebarChecked = !this.isSidebarChecked;
         this.pcodedSidebarPosition = this.isSidebarChecked === true ? 'fixed' : 'absolute';
         this.sidebarFixedHeight = this.isSidebarChecked === true ? 'calc(100vh - 50px)' : '100%';
         
         if (this.isHeaderChecked === false) {
            window.addEventListener('scroll', this.scroll, true);
            window.scrollTo(0, 0);
         }
      }
   }
   
   setHeaderPosition() {
      this.isHeaderChecked = !this.isHeaderChecked;
      this.pcodedHeaderPosition = this.isHeaderChecked === true ? 'fixed' : 'relative';
      this.headerFixedMargin = this.isHeaderChecked === true ? '50px' : '';
      
      if (this.isHeaderChecked === false) {
         window.addEventListener('scroll', this.scroll, true);
         window.scrollTo(0, 0);
      } else {
         window.removeEventListener('scroll', this.scroll, true);
         
         if (this.pcodedDeviceType === 'desktop') {
            this.headerFixedTop = 'auto';
         }
         
         this.pcodedSidebarPosition = 'fixed';
         
         if (this.verticalNavType !== 'collapsed') {
            this.sidebarFixedHeight = this.isSidebarChecked === true ? 'calc(100vh - 50px)' : 'calc(100vh + 50px)';
         }
      }
   }
}
